var _excluded = ["modules"],
  _excluded2 = ["modules"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { merge } from 'lodash-es';
import * as Parchment from 'parchment';
import Delta from 'quill-delta';
import Editor from './editor.js';
import Emitter from './emitter.js';
import instances from './instances.js';
import logger from './logger.js';
import Module from './module.js';
import Selection, { Range } from './selection.js';
import Composition from './composition.js';
import Theme from './theme.js';
import _scrollRectIntoView from './utils/scrollRectIntoView.js';
import createRegistryWithFormats from './utils/createRegistryWithFormats.js';
var debug = logger('quill');
var globalRegistry = new Parchment.Registry();
Parchment.ParentBlot.uiClass = 'ql-ui';

/**
 * Options for initializing a Quill instance
 */

/**
 * Similar to QuillOptions, but with all properties expanded to their default values,
 * and all selectors resolved to HTMLElements.
 */
var Quill = /*#__PURE__*/function () {
  function Quill(container) {
    var _this = this;
    _classCallCheck(this, Quill);
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.options = expandConfig(container, options);
    this.container = this.options.container;
    if (this.container == null) {
      debug.error('Invalid Quill container', container);
      return;
    }
    if (this.options.debug) {
      Quill.debug(this.options.debug);
    }
    var html = this.container.innerHTML.trim();
    this.container.classList.add('ql-container');
    this.container.innerHTML = '';
    instances.set(this.container, this);
    this.root = this.addContainer('ql-editor');
    this.root.classList.add('ql-blank');
    this.emitter = new Emitter();
    var scrollBlotName = Parchment.ScrollBlot.blotName;
    var ScrollBlot = this.options.registry.query(scrollBlotName);
    if (!ScrollBlot || !('blotName' in ScrollBlot)) {
      throw new Error("Cannot initialize Quill without \"".concat(scrollBlotName, "\" blot"));
    }
    this.scroll = new ScrollBlot(this.options.registry, this.root, {
      emitter: this.emitter
    });
    this.editor = new Editor(this.scroll);
    this.selection = new Selection(this.scroll, this.emitter);
    this.composition = new Composition(this.scroll, this.emitter);
    this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
    this.keyboard = this.theme.addModule('keyboard');
    this.clipboard = this.theme.addModule('clipboard');
    this.history = this.theme.addModule('history');
    this.uploader = this.theme.addModule('uploader');
    this.theme.addModule('input');
    this.theme.addModule('uiNode');
    this.theme.init();
    this.emitter.on(Emitter.events.EDITOR_CHANGE, function (type) {
      if (type === Emitter.events.TEXT_CHANGE) {
        _this.root.classList.toggle('ql-blank', _this.editor.isBlank());
      }
    });
    this.emitter.on(Emitter.events.SCROLL_UPDATE, function (source, mutations) {
      var oldRange = _this.selection.lastRange;
      var _this$selection$getRa = _this.selection.getRange(),
        _this$selection$getRa2 = _slicedToArray(_this$selection$getRa, 1),
        newRange = _this$selection$getRa2[0];
      var selectionInfo = oldRange && newRange ? {
        oldRange: oldRange,
        newRange: newRange
      } : undefined;
      modify.call(_this, function () {
        return _this.editor.update(null, mutations, selectionInfo);
      }, source);
    });
    this.emitter.on(Emitter.events.SCROLL_EMBED_UPDATE, function (blot, delta) {
      var oldRange = _this.selection.lastRange;
      var _this$selection$getRa3 = _this.selection.getRange(),
        _this$selection$getRa4 = _slicedToArray(_this$selection$getRa3, 1),
        newRange = _this$selection$getRa4[0];
      var selectionInfo = oldRange && newRange ? {
        oldRange: oldRange,
        newRange: newRange
      } : undefined;
      modify.call(_this, function () {
        var change = new Delta().retain(blot.offset(_this)).retain(_defineProperty({}, blot.statics.blotName, delta));
        return _this.editor.update(change, [], selectionInfo);
      }, Quill.sources.USER);
    });
    if (html) {
      var contents = this.clipboard.convert({
        html: "".concat(html, "<p><br></p>"),
        text: '\n'
      });
      this.setContents(contents);
    }
    this.history.clear();
    if (this.options.placeholder) {
      this.root.setAttribute('data-placeholder', this.options.placeholder);
    }
    if (this.options.readOnly) {
      this.disable();
    }
    this.allowReadOnlyEdits = false;
  }
  _createClass(Quill, [{
    key: "addContainer",
    value: function addContainer(container) {
      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (typeof container === 'string') {
        var className = container;
        container = document.createElement('div');
        container.classList.add(className);
      }
      this.container.insertBefore(container, refNode);
      return container;
    }
  }, {
    key: "blur",
    value: function blur() {
      this.selection.setRange(null);
    }
  }, {
    key: "deleteText",
    value: function deleteText(index, length, source) {
      var _this2 = this;
      // @ts-expect-error
      var _overload = overload(index, length, source);
      var _overload2 = _slicedToArray(_overload, 4);
      index = _overload2[0];
      length = _overload2[1];
      source = _overload2[3];
      return modify.call(this, function () {
        return _this2.editor.deleteText(index, length);
      }, source, index, -1 * length);
    }
  }, {
    key: "disable",
    value: function disable() {
      this.enable(false);
    }
  }, {
    key: "editReadOnly",
    value: function editReadOnly(modifier) {
      this.allowReadOnlyEdits = true;
      var value = modifier();
      this.allowReadOnlyEdits = false;
      return value;
    }
  }, {
    key: "enable",
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.scroll.enable(enabled);
      this.container.classList.toggle('ql-disabled', !enabled);
    }
  }, {
    key: "focus",
    value: function focus() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.selection.focus();
      if (!options.preventScroll) {
        this.scrollSelectionIntoView();
      }
    }
  }, {
    key: "format",
    value: function format(name, value) {
      var _this3 = this;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Emitter.sources.API;
      return modify.call(this, function () {
        var range = _this3.getSelection(true);
        var change = new Delta();
        if (range == null) return change;
        if (_this3.scroll.query(name, Parchment.Scope.BLOCK)) {
          change = _this3.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
        } else if (range.length === 0) {
          _this3.selection.format(name, value);
          return change;
        } else {
          change = _this3.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
        }
        _this3.setSelection(range, Emitter.sources.SILENT);
        return change;
      }, source);
    }
  }, {
    key: "formatLine",
    value: function formatLine(index, length, name, value, source) {
      var _this4 = this;
      var formats;
      // eslint-disable-next-line prefer-const
      var _overload3 = overload(index, length,
      // @ts-expect-error
      name, value, source);
      var _overload4 = _slicedToArray(_overload3, 4);
      index = _overload4[0];
      length = _overload4[1];
      formats = _overload4[2];
      source = _overload4[3];
      return modify.call(this, function () {
        return _this4.editor.formatLine(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: "formatText",
    value: function formatText(index, length, name, value, source) {
      var _this5 = this;
      var formats;
      // eslint-disable-next-line prefer-const
      var _overload5 = overload(
      // @ts-expect-error
      index, length, name, value, source);
      var _overload6 = _slicedToArray(_overload5, 4);
      index = _overload6[0];
      length = _overload6[1];
      formats = _overload6[2];
      source = _overload6[3];
      return modify.call(this, function () {
        return _this5.editor.formatText(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: "getBounds",
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var bounds = null;
      if (typeof index === 'number') {
        bounds = this.selection.getBounds(index, length);
      } else {
        bounds = this.selection.getBounds(index.index, index.length);
      }
      if (!bounds) return null;
      var containerBounds = this.container.getBoundingClientRect();
      return {
        bottom: bounds.bottom - containerBounds.top,
        height: bounds.height,
        left: bounds.left - containerBounds.left,
        right: bounds.right - containerBounds.left,
        top: bounds.top - containerBounds.top,
        width: bounds.width
      };
    }
  }, {
    key: "getContents",
    value: function getContents() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
      var _overload7 = overload(index, length);
      var _overload8 = _slicedToArray(_overload7, 2);
      index = _overload8[0];
      length = _overload8[1];
      return this.editor.getContents(index, length);
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (typeof index === 'number') {
        return this.editor.getFormat(index, length);
      }
      return this.editor.getFormat(index.index, index.length);
    }
  }, {
    key: "getIndex",
    value: function getIndex(blot) {
      return blot.offset(this.scroll);
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this.scroll.length();
    }
  }, {
    key: "getLeaf",
    value: function getLeaf(index) {
      return this.scroll.leaf(index);
    }
  }, {
    key: "getLine",
    value: function getLine(index) {
      return this.scroll.line(index);
    }
  }, {
    key: "getLines",
    value: function getLines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
      if (typeof index !== 'number') {
        return this.scroll.lines(index.index, index.length);
      }
      return this.scroll.lines(index, length);
    }
  }, {
    key: "getModule",
    value: function getModule(name) {
      return this.theme.modules[name];
    }
  }, {
    key: "getSelection",
    value: function getSelection() {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (focus) this.focus();
      this.update(); // Make sure we access getRange with editor in consistent state
      return this.selection.getRange()[0];
    }
  }, {
    key: "getSemanticHTML",
    value: function getSemanticHTML() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 ? arguments[1] : undefined;
      if (typeof index === 'number') {
        var _length;
        length = (_length = length) !== null && _length !== void 0 ? _length : this.getLength() - index;
      }
      // @ts-expect-error
      var _overload9 = overload(index, length);
      var _overload10 = _slicedToArray(_overload9, 2);
      index = _overload10[0];
      length = _overload10[1];
      return this.editor.getHTML(index, length);
    }
  }, {
    key: "getText",
    value: function getText() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 ? arguments[1] : undefined;
      if (typeof index === 'number') {
        var _length2;
        length = (_length2 = length) !== null && _length2 !== void 0 ? _length2 : this.getLength() - index;
      }
      // @ts-expect-error
      var _overload11 = overload(index, length);
      var _overload12 = _slicedToArray(_overload11, 2);
      index = _overload12[0];
      length = _overload12[1];
      return this.editor.getText(index, length);
    }
  }, {
    key: "hasFocus",
    value: function hasFocus() {
      return this.selection.hasFocus();
    }
  }, {
    key: "insertEmbed",
    value: function insertEmbed(index, embed, value) {
      var _this6 = this;
      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
      return modify.call(this, function () {
        return _this6.editor.insertEmbed(index, embed, value);
      }, source, index);
    }
  }, {
    key: "insertText",
    value: function insertText(index, text, name, value, source) {
      var _this7 = this;
      var formats;
      // eslint-disable-next-line prefer-const
      // @ts-expect-error
      var _overload13 = overload(index, 0, name, value, source);
      var _overload14 = _slicedToArray(_overload13, 4);
      index = _overload14[0];
      formats = _overload14[2];
      source = _overload14[3];
      return modify.call(this, function () {
        return _this7.editor.insertText(index, text, formats);
      }, source, index, text.length);
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.scroll.isEnabled();
    }
  }, {
    key: "off",
    value: function off() {
      var _this$emitter;
      return (_this$emitter = this.emitter).off.apply(_this$emitter, arguments);
    }
  }, {
    key: "on",
    value: function on() {
      var _this$emitter2;
      return (_this$emitter2 = this.emitter).on.apply(_this$emitter2, arguments);
    }
  }, {
    key: "once",
    value: function once() {
      var _this$emitter3;
      return (_this$emitter3 = this.emitter).once.apply(_this$emitter3, arguments);
    }
  }, {
    key: "removeFormat",
    value: function removeFormat(index, length, source) {
      var _this8 = this;
      var _overload15 = overload(index, length, source);
      var _overload16 = _slicedToArray(_overload15, 4);
      index = _overload16[0];
      length = _overload16[1];
      source = _overload16[3];
      return modify.call(this, function () {
        return _this8.editor.removeFormat(index, length);
      }, source, index);
    }
  }, {
    key: "scrollRectIntoView",
    value: function scrollRectIntoView(rect) {
      _scrollRectIntoView(this.root, rect);
    }

    /**
     * @deprecated Use Quill#scrollSelectionIntoView() instead.
     */
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView() {
      console.warn('Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.');
      this.scrollSelectionIntoView();
    }

    /**
     * Scroll the current selection into the visible area.
     * If the selection is already visible, no scrolling will occur.
     */
  }, {
    key: "scrollSelectionIntoView",
    value: function scrollSelectionIntoView() {
      var range = this.selection.lastRange;
      var bounds = range && this.selection.getBounds(range.index, range.length);
      if (bounds) {
        this.scrollRectIntoView(bounds);
      }
    }
  }, {
    key: "setContents",
    value: function setContents(delta) {
      var _this9 = this;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Emitter.sources.API;
      return modify.call(this, function () {
        delta = new Delta(delta);
        var length = _this9.getLength();
        // Quill will set empty editor to \n
        var delete1 = _this9.editor.deleteText(0, length);
        var applied = _this9.editor.insertContents(0, delta);
        // Remove extra \n from empty editor initialization
        var delete2 = _this9.editor.deleteText(_this9.getLength() - 1, 1);
        return delete1.compose(applied).compose(delete2);
      }, source);
    }
  }, {
    key: "setSelection",
    value: function setSelection(index, length, source) {
      if (index == null) {
        // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
        this.selection.setRange(null, length || Quill.sources.API);
      } else {
        // @ts-expect-error
        var _overload17 = overload(index, length, source);
        var _overload18 = _slicedToArray(_overload17, 4);
        index = _overload18[0];
        length = _overload18[1];
        source = _overload18[3];
        this.selection.setRange(new Range(Math.max(0, index), length), source);
        if (source !== Emitter.sources.SILENT) {
          this.scrollSelectionIntoView();
        }
      }
    }
  }, {
    key: "setText",
    value: function setText(text) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Emitter.sources.API;
      var delta = new Delta().insert(text);
      return this.setContents(delta, source);
    }
  }, {
    key: "update",
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Emitter.sources.USER;
      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
      this.selection.update(source);
      // TODO this is usually undefined
      return change;
    }
  }, {
    key: "updateContents",
    value: function updateContents(delta) {
      var _this10 = this;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Emitter.sources.API;
      return modify.call(this, function () {
        delta = new Delta(delta);
        return _this10.editor.applyDelta(delta);
      }, source, true);
    }
  }], [{
    key: "debug",
    value: function debug(limit) {
      if (limit === true) {
        limit = 'log';
      }
      logger.level(limit);
    }
  }, {
    key: "find",
    value: function find(node) {
      var bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return instances.get(node) || globalRegistry.find(node, bubble);
    }
  }, {
    key: "import",
    value: function _import(name) {
      if (this.imports[name] == null) {
        debug.error("Cannot import ".concat(name, ". Are you sure it was registered?"));
      }
      return this.imports[name];
    }
  }, {
    key: "register",
    value: function register() {
      var _this11 = this;
      if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== 'string') {
        var target = arguments.length <= 0 ? undefined : arguments[0];
        var overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
        var name = 'attrName' in target ? target.attrName : target.blotName;
        if (typeof name === 'string') {
          // Shortcut for formats:
          // register(Blot | Attributor, overwrite)
          this.register("formats/".concat(name), target, overwrite);
        } else {
          Object.keys(target).forEach(function (key) {
            _this11.register(key, target[key], overwrite);
          });
        }
      } else {
        var path = arguments.length <= 0 ? undefined : arguments[0];
        var _target = arguments.length <= 1 ? undefined : arguments[1];
        var _overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
        if (this.imports[path] != null && !_overwrite) {
          debug.warn("Overwriting ".concat(path, " with"), _target);
        }
        this.imports[path] = _target;
        if ((path.startsWith('blots/') || path.startsWith('formats/')) && _target && typeof _target !== 'boolean' && _target.blotName !== 'abstract') {
          globalRegistry.register(_target);
        }
        if (typeof _target.register === 'function') {
          _target.register(globalRegistry);
        }
      }
    }
  }]);
  return Quill;
}();
_defineProperty(Quill, "DEFAULTS", {
  bounds: null,
  modules: {
    clipboard: true,
    keyboard: true,
    history: true,
    uploader: true
  },
  placeholder: '',
  readOnly: false,
  registry: globalRegistry,
  theme: 'default'
});
_defineProperty(Quill, "events", Emitter.events);
_defineProperty(Quill, "sources", Emitter.sources);
_defineProperty(Quill, "version", typeof "2.0.3" === 'undefined' ? 'dev' : "2.0.3");
_defineProperty(Quill, "imports", {
  delta: Delta,
  parchment: Parchment,
  'core/module': Module,
  'core/theme': Theme
});
function resolveSelector(selector) {
  return typeof selector === 'string' ? document.querySelector(selector) : selector;
}
function expandModuleConfig(config) {
  return Object.entries(config !== null && config !== void 0 ? config : {}).reduce(function (expanded, _ref) {
    var _ref3 = _slicedToArray(_ref, 2),
      key = _ref3[0],
      value = _ref3[1];
    return _objectSpread(_objectSpread({}, expanded), {}, _defineProperty({}, key, value === true ? {} : value));
  }, {});
}
function omitUndefinedValuesFromOptions(obj) {
  return Object.fromEntries(Object.entries(obj).filter(function (entry) {
    return entry[1] !== undefined;
  }));
}
function expandConfig(containerOrSelector, options) {
  var container = resolveSelector(containerOrSelector);
  if (!container) {
    throw new Error('Invalid Quill container');
  }
  var shouldUseDefaultTheme = !options.theme || options.theme === Quill.DEFAULTS.theme;
  var theme = shouldUseDefaultTheme ? Theme : Quill["import"]("themes/".concat(options.theme));
  if (!theme) {
    throw new Error("Invalid theme ".concat(options.theme, ". Did you register it?"));
  }
  var _Quill$DEFAULTS = Quill.DEFAULTS,
    quillModuleDefaults = _Quill$DEFAULTS.modules,
    quillDefaults = _objectWithoutProperties(_Quill$DEFAULTS, _excluded);
  var _theme$DEFAULTS = theme.DEFAULTS,
    themeModuleDefaults = _theme$DEFAULTS.modules,
    themeDefaults = _objectWithoutProperties(_theme$DEFAULTS, _excluded2);
  var userModuleOptions = expandModuleConfig(options.modules);
  // Special case toolbar shorthand
  if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) {
    userModuleOptions = _objectSpread(_objectSpread({}, userModuleOptions), {}, {
      toolbar: {
        container: userModuleOptions.toolbar
      }
    });
  }
  var modules = merge({}, expandModuleConfig(quillModuleDefaults), expandModuleConfig(themeModuleDefaults), userModuleOptions);
  var config = _objectSpread(_objectSpread(_objectSpread({}, quillDefaults), omitUndefinedValuesFromOptions(themeDefaults)), omitUndefinedValuesFromOptions(options));
  var registry = options.registry;
  if (registry) {
    if (options.formats) {
      debug.warn('Ignoring "formats" option because "registry" is specified');
    }
  } else {
    registry = options.formats ? createRegistryWithFormats(options.formats, config.registry, debug) : config.registry;
  }
  return _objectSpread(_objectSpread({}, config), {}, {
    registry: registry,
    container: container,
    theme: theme,
    modules: Object.entries(modules).reduce(function (modulesWithDefaults, _ref2) {
      var _ref4 = _slicedToArray(_ref2, 2),
        name = _ref4[0],
        value = _ref4[1];
      if (!value) return modulesWithDefaults;
      var moduleClass = Quill["import"]("modules/".concat(name));
      if (moduleClass == null) {
        debug.error("Cannot load ".concat(name, " module. Are you sure you registered it?"));
        return modulesWithDefaults;
      }
      return _objectSpread(_objectSpread({}, modulesWithDefaults), {}, _defineProperty({}, name, merge({}, moduleClass.DEFAULTS || {}, value)));
    }, {}),
    bounds: resolveSelector(config.bounds)
  });
}

// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function modify(modifier, source, index, shift) {
  if (!this.isEnabled() && source === Emitter.sources.USER && !this.allowReadOnlyEdits) {
    return new Delta();
  }
  var range = index == null ? null : this.getSelection();
  var oldDelta = this.editor.delta;
  var change = modifier();
  if (range != null) {
    if (index === true) {
      index = range.index; // eslint-disable-line prefer-destructuring
    }

    if (shift == null) {
      range = shiftRange(range, change, source);
    } else if (shift !== 0) {
      // @ts-expect-error index should always be number
      range = shiftRange(range, index, shift, source);
    }
    this.setSelection(range, Emitter.sources.SILENT);
  }
  if (change.length() > 0) {
    var _this$emitter4;
    var args = [Emitter.events.TEXT_CHANGE, change, oldDelta, source];
    (_this$emitter4 = this.emitter).emit.apply(_this$emitter4, [Emitter.events.EDITOR_CHANGE].concat(args));
    if (source !== Emitter.sources.SILENT) {
      var _this$emitter5;
      (_this$emitter5 = this.emitter).emit.apply(_this$emitter5, args);
    }
  }
  return change;
}
function overload(index, length, name, value, source) {
  var formats = {};
  // @ts-expect-error
  if (typeof index.index === 'number' && typeof index.length === 'number') {
    // Allow for throwaway end (used by insertText/insertEmbed)
    if (typeof length !== 'number') {
      // @ts-expect-error
      source = value;
      value = name;
      name = length;
      // @ts-expect-error
      length = index.length; // eslint-disable-line prefer-destructuring
      // @ts-expect-error
      index = index.index; // eslint-disable-line prefer-destructuring
    } else {
      // @ts-expect-error
      length = index.length; // eslint-disable-line prefer-destructuring
      // @ts-expect-error
      index = index.index; // eslint-disable-line prefer-destructuring
    }
  } else if (typeof length !== 'number') {
    // @ts-expect-error
    source = value;
    value = name;
    name = length;
    length = 0;
  }
  // Handle format being object, two format name/value strings or excluded
  if (_typeof(name) === 'object') {
    // @ts-expect-error Fix me later
    formats = name;
    // @ts-expect-error
    source = value;
  } else if (typeof name === 'string') {
    if (value != null) {
      formats[name] = value;
    } else {
      // @ts-expect-error
      source = name;
    }
  }
  // Handle optional source
  source = source || Emitter.sources.API;
  // @ts-expect-error
  return [index, length, formats, source];
}
function shiftRange(range, index, lengthOrSource, source) {
  var length = typeof lengthOrSource === 'number' ? lengthOrSource : 0;
  if (range == null) return null;
  var start;
  var end;
  // @ts-expect-error -- TODO: add a better type guard around `index`
  if (index && typeof index.transformPosition === 'function') {
    var _map = [range.index, range.index + range.length].map(function (pos) {
      return (
        // @ts-expect-error -- TODO: add a better type guard around `index`
        index.transformPosition(pos, source !== Emitter.sources.USER)
      );
    });
    var _map2 = _slicedToArray(_map, 2);
    start = _map2[0];
    end = _map2[1];
  } else {
    var _map3 = [range.index, range.index + range.length].map(function (pos) {
      // @ts-expect-error -- TODO: add a better type guard around `index`
      if (pos < index || pos === index && source === Emitter.sources.USER) return pos;
      if (length >= 0) {
        return pos + length;
      }
      // @ts-expect-error -- TODO: add a better type guard around `index`
      return Math.max(index, pos + length);
    });
    var _map4 = _slicedToArray(_map3, 2);
    start = _map4[0];
    end = _map4[1];
  }
  return new Range(start, end - start);
}
export { Parchment, Range };
export { globalRegistry, expandConfig, overload, Quill as default };